import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppHelper } from 'src/app/helpers/app.helper';
import { AppModesEnum } from 'src/app/models/WebServer/appModesEnum';
import { MediaTypesEnum } from 'src/app/models/WebServer/mediaTypesEnum';
import { Message } from 'src/app/models/WebServer/message';
import { PartecipantInfo } from 'src/app/models/WebServer/partecipantInfo';
import { AppConfigService } from 'src/app/services/app.config.service';
import { RootState } from 'src/app/store/root.state';
import { AppState, initialAppState } from 'src/app/store/states/app.state';
import { SvgConstants } from 'src/app/svgConstants';

import { Subject, takeUntil } from 'rxjs';
import { BrowserHelper } from 'src/app/helpers/browser.helper';
import { LanguageCode } from 'src/app/models/languageCode';
import { PartecipantRoles } from 'src/app/models/WebServer/partecipantRoles';
import { TranslationInfo } from 'src/app/models/WebServer/translationInfo';
import { toTranslationInfo } from 'src/app/models/WebServer/translationResponse';
import { FileCategory } from 'src/app/pipes/textMessageIcon.pipe';
import { I18Service } from 'src/app/services/i18.service';
import { TextTranslationService } from 'src/app/services/textTranslation.service';
import * as appActions from "src/app/store/actions/app.actions";
import * as selectorState from "src/app/store/selectors/app.selectors";


@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() disabled!: boolean;
  @Input('shown') set shown(b: boolean) {
    this._shown = b;
    if (b && !this.scrollBottomVisible) {
      this.scrollBottom();
    }
  }
  @Input('userLanguage') set userLanguage(l: string) {
    if (l) {
      l = l.split('-')[0];

      const storedTranslationLanguage = localStorage.getItem(ChatComponent.storageKey);
      if (storedTranslationLanguage){
        const translationLanguage = JSON.parse(storedTranslationLanguage);
        if (translationLanguage.sessionId == this.config.sessionId) {
          this.autoTranslateChecked = translationLanguage.auto;
          setTimeout(() => { // dispatchiamo in ritardo, così da evitare le prime emissioni che sovrasciveranno il localstorage
            this.store.dispatch(appActions.translationSelectedLanguage({lang: translationLanguage.languageCode}));
            this.store.dispatch(appActions.translationAuto({auto: translationLanguage.auto}));

          }, 500);
          return; // C'è già localStorage per questa sessione: non sovrascrivere con la lingua del browser
        }
      }
      // Nessun localStorage valido: usa la lingua del browser del cittadino
      this.changeSelectedLanguageCode(l);

    }
  }

  FileCategory = FileCategory;

  _shown = false;

  @Input() AS!: AppState;
  @ViewChild('messagelist', { read: ElementRef }) messagelist!: ElementRef;
  @ViewChild('chatText', { read: ElementRef }) chatText!: ElementRef;
  @ViewChild('translateText', { read: ElementRef }) translateText!: ElementRef;

  MediaTypesEnum = MediaTypesEnum
  appModes = AppModesEnum;
  public chatIncomingSound: any;
  appHelper = AppHelper;
  PartecipantRoles = PartecipantRoles;

  remoteContent = '';
  chatBuffer = '';
  public inputMessage: string = '';
  messageTimer: any = null;
  container?: HTMLElement;
  files?: FileList;
  fileName?: string;
  resizedSize?: number;
  actualFileSize?: number;
  interlocutor?: PartecipantInfo;
  phoneModel?: string;
  mediaLink?: string;
  audioEnabled = false;
  today: Date;
  svgConstants = SvgConstants;
  translationInfo?: TranslationInfo;
  selectedLanguageCode = initialAppState.translationSelectedLanguage;// Constants.DEFAULT_LANGUAGE;
  showTranslationBox = false;
  scrollBottomVisible = false;
  autoTranslateChecked = false;
  languageList: LanguageCode[] = []
  destroy$: Subject<boolean> = new Subject<boolean>();

  contentEditable='true'
  private static get storageKey() { return `${AppConfigService.role}.ChatTranslationLanguage`; }

  constructor(
    private store: Store<RootState>,
    public config: AppConfigService,
    public textTranslationService: TextTranslationService
  ) {

    this.chatIncomingSound = new Audio('assets/audio/chat_incoming.mp3');
    this.chatIncomingSound.loop = false;
    this.chatIncomingSound.muted = false;
    this.today = new Date();
    
    if (BrowserHelper.supportsPlainText()) {
      this.contentEditable = 'plaintext-only'; // blocco digitazione solo plaintext-only nn funziona su firefox
    }

    
    this.store.select(selectorState.guiLanguage).pipe(takeUntil(this.destroy$)).subscribe(l => {
      // this.selectedLanguageCode = config.language;
      this.languageList = I18Service.availableTranslations();
      console.log(`I18Service.LANGUAGE_CHANGE => ${l}`, this.languageList)
    });
  }

  ngAfterViewInit(): void {
    this.store.select(selectorState.translationSelectedLanguage).pipe(takeUntil(this.destroy$)).subscribe(l => {
      if(l) {
        this.selectedLanguageCode = l;
        localStorage.setItem(ChatComponent.storageKey, JSON.stringify({sessionId: this.config.sessionId, languageCode: l, auto: this.autoTranslateChecked}))
      }
    })
    
    const ne = this.messagelist?.nativeElement;
    if (ne) {
      // detect dello scroll per attivare il pulsante scroll bottom 
      ne.addEventListener('scroll', (event: any) => this.onScrollChat());

      // nel caso non sia attivo pulsante (lista scrollata in basso), in nuovi messaggi autoscroll
      const observer = new MutationObserver((mutations, observer) => {
        if (!this.scrollBottomVisible && this._shown) {
          this.scrollBottom();
        }
      });
      observer.observe(ne, { subtree: true, attributes: true });
      // this.scrollBottom(); // porta all'ultimo messaggio all'avvio 
    }
  }

  ngOnDestroy(): void {
    console.log(`ngOndestroy chat.component`)
    this.destroy$.next(true);
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }

  ngOnInit() {
  }

  private comunicateAllRead() {
    if (!this._shown || !this.AS.unreadMessage || this.scrollBottomVisible) return;
    this.store.dispatch(appActions.markMessageAsRead({ message: 'all' }))
  }

  private onScrollChat() {
    this.scrollBottomVisible = this.checkScrollCondition();
    this.comunicateAllRead();
  }

  private checkScrollCondition(): boolean {
    const ne = this.messagelist?.nativeElement;
    if (ne) {
      let scrollHeight: number = ne.scrollHeight;
      let scrollTop: number = ne.scrollTop;
      let clientHeight: number = ne.clientHeight;
      let remainingHeigth: number = (scrollHeight - scrollTop) - clientHeight;
      return remainingHeigth > 20; // && remainingHeigth > 0;
    }
    return true;
  }

  scrollBottom() {
    window.setTimeout(() => {
      const ne = this.messagelist?.nativeElement;
      if (ne) {
        ne.scrollTop = ne.scrollHeight;
      }
    }, 100)

    if (this._shown && this.AS.unreadMessage) {
      this.comunicateAllRead();
    }
  }

  public sendSpanMessageWithButton() { //TODO -done
    if (this.inputMessage) {
      const msg = this.chatText.nativeElement.textContent.trim();
      if(!this.config.isCaller){
        this.SendTranslateMessage(msg);
      }
      else{
        this.finishSendMessage(msg);
      }
    }
  }

  private SendTranslateMessage(msg: string) {
    if(this.autoTranslateChecked){
      this.textTranslationService.translateText(msg, this.config.language, this.selectedLanguageCode.code!)
        .then( tr => {
          this.translationInfo = toTranslationInfo(tr, this.config.partecipantId);
          this.finishSendMessage(msg);
        })


    }
    else if(this.translationInfo){
      this.translationInfo.translatedText = this.translateText.nativeElement.textContent.trim();
      this.finishSendMessage(msg);
    }
    else{
      this.finishSendMessage(msg);
    }
  }

  private finishSendMessage(msg: string){
    this.store.dispatch(appActions.sendTextMessage({ body: msg, id: AppHelper.newUUID, trInfo: this.translationInfo ? [this.translationInfo] : undefined, toIds: appActions.SEND_TO_ALL }));
    this.clearMessage();
  }

  public translateChatMessage(message: Message){
    this.textTranslationService.translateChatMessage(message, this.selectedLanguageCode.code, this.autoTranslateChecked, true)
    .then( (resp) => {});

  }
  public detectAndTranslateChatMessage(message: Message){

    this.textTranslationService.translateChatMessage(message, this.selectedLanguageCode.code, this.autoTranslateChecked)
    .then( (resp) => {
      // if(resp.isCaller && resp.tr.confidence >= this.config.agencySettings.translationMaxConfidence) {
      //   this.changeSelectedLanguageCode(resp.tr.startingLanguage);
      // }
    });

  }

  public translateSendMessageClick(){
    if(this.inputMessage && !this.autoTranslateChecked){
      this.textTranslationService.translateText(this.inputMessage, this.config.language, this.selectedLanguageCode.code)
        .then( tr =>{
          this.showTranslationBox = true;
          this.translationInfo = toTranslationInfo(tr, this.config.partecipantId);
          
          this.translateText.nativeElement.innerHTML = tr.translatedText; 
        })



    }
  }

  public clearMessage() {
    this.chatText.nativeElement.textContent = '';
    this.chatText.nativeElement.innerHTML = ''
    this.inputMessage = '';

    this.clearTranslateMessage();
    this.placeCaretAtEnd();
  }

  public clearTranslateMessage(){      
    if((this.AS.session.config.agencySettings)?.enableTranslation && !this.config.isCaller) {
      this.translateText.nativeElement.textContent = ''
      this.translateText.nativeElement.innerHTML = ''
      this.translationInfo = undefined;
    }
    // this.showTranslationBox = false;
  }

  public spanKeyPress(key: KeyboardEvent): void {
    if (!key) {
      return;
    }

    const pressedKey = key.code || key.key;
    // console.log(`pressedKey: ${pressedKey}`);
    if ((pressedKey == 'Enter' || pressedKey == 'NumpadEnter') && !key.shiftKey) {
      key.preventDefault();
      this.sendSpanMessageWithButton();
    }
  }
  public changeInput(event: Event) {
    this.inputMessage = this.chatText.nativeElement.textContent.trim();
    // console.log(`changeInput: ${this.inputMessage}`);
    if (!this.inputMessage){
      this.clearTranslateMessage();
    }
  }

  public managePaste() {

    setTimeout(() => { // rimuove formattazioni strane
      const pasted = this.chatText.nativeElement.textContent.trim();
      this.chatText.nativeElement.innerHTML = pasted;
      this.inputMessage = pasted;
      this.placeCaretAtEnd();
    }, 0);
  }

  private placeCaretAtEnd() {
    const el = this.chatText.nativeElement;
    el.focus();
    if (typeof window.getSelection != "undefined"
      && typeof document.createRange != "undefined") {
      var range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      const sel = window.getSelection();
      if (sel) {
        sel?.removeAllRanges();
        sel?.addRange(range);
      }
    } else if (typeof (<any>document.body).createTextRange != "undefined") {
      var textRange = (<any>document.body).createTextRange();
      textRange.moveToElementText(el);
      textRange.collapse(false);
      textRange.select();
    }
  }

  changeSelectedLanguageCode(value: string): void {

    this.store.dispatch(appActions.translationSelectedLanguage({lang: I18Service.getLanguageCode(value)}));
  }
  changeAutoTranslate(checked: boolean) {
    this.store.dispatch(appActions.translationAuto({auto: checked}));
  }

  /**
   * TrackBy function per ngFor dei messaggi
   * Previene la ricreazione inutile dei componenti chat-preview
   * quando l'array messages cambia riferimento ma i contenuti sono gli stessi
   */
  trackByMessageIdx(index: number, message: Message): number {
    return message.idx; // Usa idx che è unico per messaggio
  }
}
